export default __webpack_public_path__ + "static/media/RSI.b6966a55.md";